var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E91BA5D5-8BEB-4C97-B0D2-7424C33C16F6@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDEA7-web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mais-web-2-2",
    transform: "translate(-1290.000000, -452.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Select",
    transform: "translate(120.000000, 296.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bank-card-copy-5",
    transform: "translate(807.000000, 148.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/info",
    transform: "translate(363.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#EEF0F1",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0102539,8.359375 C12.2563477,8.359375 12.4431966,8.29101562 12.5708008,8.15429688 C12.6984049,8.01757812 12.762207,7.84667969 12.762207,7.64160156 C12.762207,7.43652344 12.6984049,7.26334635 12.5708008,7.12207031 C12.4431966,6.98079427 12.2563477,6.91015625 12.0102539,6.91015625 C11.7641602,6.91015625 11.5784505,6.98079427 11.453125,7.12207031 C11.3277995,7.26334635 11.2651367,7.43652344 11.2651367,7.64160156 C11.2651367,7.84667969 11.3277995,8.01757812 11.453125,8.15429688 C11.5784505,8.29101562 11.7641602,8.359375 12.0102539,8.359375 Z M12.6323242,17 L12.6323242,9.60351562 L11.3676758,9.60351562 L11.3676758,17 L12.6323242,17 Z",
    id: "i",
    fill: "#5E5E7E",
    fillRule: "nonzero"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.045944c6eb59b3e8affc74ca3962b217.svg";
export { ForwardRef as ReactComponent };